var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { Typography, TextField, Button, Link, FormLabel, FormController, Dropdown, MenuItem, FormStatusMessage, Alert, } from '@one-thd/sui-atomic-components';
import Papa from 'papaparse';
import { Pagination } from '@thd-olt-component-react/pagination';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { scrollToTop } from '../../../utils/general';
import { convertStringToBlobCSV, mapFieldsToCSVModel, } from '../../../utils/bulk-add';
import { RemoveInvalidUsers, } from '../../modal/bulk-add/remove-invalid-users/remove-invalid-users';
import { NoValidUsersModal, } from '../../modal/bulk-add/no-valid-users-modal/no-valid-users-modal';
import { useAddManageUsers } from '../../../hooks/use-add-manage-users';
import { getNewPageNumber } from '../../../utils/pagination';
import { BULK_ADD_USERS_PAGE_SIZE } from '../../../constants/general';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { ROLE_VALUES } from '../../../constants/bulk-add';
import { validationSchema } from '../validation';
import { useModal } from '../../../hooks/use-modal';
import { setBulkAddEventAnalytics } from '../../../utils/add-manage-user-analytics';
export var ImportResult = function (_a) {
    var _b, _c;
    var shouldShowImportForm = _a.shouldShowImportForm, isMaxUsers = _a.isMaxUsers, isMaxErrors = _a.isMaxErrors, filteredUsersList = _a.filteredUsersList, setUploadStep = _a.setUploadStep, handleCancelImport = _a.handleCancelImport, handleCancelImportNoValidUsers = _a.handleCancelImportNoValidUsers, onSubmit = _a.onSubmit;
    var _d = useModal(), openModal = _d.openModal, hideModal = _d.hideModal;
    var initialValidUsers = filteredUsersList.initialValidUsers, invalidUsers = filteredUsersList.invalidUsers;
    var _e = useAddManageUsers(), isPartOfRunnerAllowance = _e.isPartOfRunnerAllowance, setFormMode = _e.setFormMode;
    var _f = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            users: invalidUsers,
            isPartOfRunnerAllowance: isPartOfRunnerAllowance,
        },
        mode: 'onTouched',
    }), formErrors = _f.formState.errors, control = _f.control, trigger = _f.trigger, handleSubmit = _f.handleSubmit;
    var _g = useFieldArray({
        control: control,
        name: 'users',
    }), fields = _g.fields, remove = _g.remove;
    var _h = useState(false), isInitialValidated = _h[0], setIsInitialValidated = _h[1];
    var _j = useState(1), currentPageNumber = _j[0], setCurrentPageNumber = _j[1];
    useEffect(function () {
        if (!isInitialValidated) {
            var validate = function () { return __awaiter(void 0, void 0, void 0, function () {
                var valid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, trigger()];
                        case 1:
                            valid = _a.sent();
                            setIsInitialValidated(true);
                            return [2 /*return*/, valid];
                    }
                });
            }); };
            validate();
        }
    }, []);
    var invalidUsersLength = ((_c = (_b = formErrors.users) === null || _b === void 0 ? void 0 : _b.filter) === null || _c === void 0 ? void 0 : _c.call(_b, function (error) { return error; }).length) || 0;
    var validUsersLength = fields.length - invalidUsersLength + ((initialValidUsers === null || initialValidUsers === void 0 ? void 0 : initialValidUsers.length) || 0);
    var totalUsersLength = validUsersLength + invalidUsersLength;
    var totalPages = Math.ceil(fields.length / BULK_ADD_USERS_PAGE_SIZE);
    var paginatedUsers = fields.slice((currentPageNumber - 1) * BULK_ADD_USERS_PAGE_SIZE, currentPageNumber * BULK_ADD_USERS_PAGE_SIZE);
    var fixedUsers = totalUsersLength - initialValidUsers.length - invalidUsersLength;
    useEffect(function () {
        if (isInitialValidated) {
            setBulkAddEventAnalytics("import: mixed: success>".concat(initialValidUsers.length, ": fixed>").concat(fixedUsers));
        }
    }, [fixedUsers]);
    var removeIdsFromFields = function (fieldsArray) {
        return fieldsArray.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (__assign({}, rest));
        });
    };
    var onRemove = function (index) {
        var pageNumber = getNewPageNumber(currentPageNumber, totalPages, paginatedUsers.length);
        onChangePage(pageNumber);
        remove(index);
        setBulkAddEventAnalytics('validation: invalid user: remove');
    };
    var onChangePage = function (pageNumber) {
        setCurrentPageNumber(pageNumber);
    };
    var openConfirmRemoveModal = function () {
        if (!validUsersLength) {
            openModal(NoValidUsersModal, {
                hideModal: hideModal,
                handleCancelImportNoValidUsers: handleCancelImportNoValidUsers,
                downloadHref: convertStringToBlobCSV(Papa.unparse(mapFieldsToCSVModel(fields))),
            });
            return;
        }
        openModal(RemoveInvalidUsers, {
            isLoading: false,
            hideModal: hideModal,
            usersInfo: {
                validUsersLength: validUsersLength,
                invalidUsersLength: invalidUsersLength,
                totalUsersLength: totalUsersLength,
            },
            onConfirmDelete: function () {
                var indexesToRemove = Array.isArray(formErrors === null || formErrors === void 0 ? void 0 : formErrors.users)
                    ? formErrors.users.reduce(function (acc, cur, index) {
                        if (cur !== null)
                            acc.push(index);
                        return acc;
                    }, [])
                    : [];
                remove(indexesToRemove);
                scrollToTop();
                handleSubmit(onSubmitUsers)();
                hideModal();
            },
            downloadHref: convertStringToBlobCSV(Papa.unparse(mapFieldsToCSVModel(fields))),
        });
    };
    var onSubmitUsers = function (values) {
        var usersList = __spreadArray(__spreadArray([], initialValidUsers, true), removeIdsFromFields(values.users), true);
        return onSubmit(usersList);
    };
    var maxUsersAlert = isMaxUsers && (React.createElement(Alert, { status: TAlertStatus.ERROR },
        React.createElement(Typography, { variant: "body-base" }, "Your file contains over 500 entries. Please split your file into multiple CSV files before you import.")));
    var maxErrorsAlert = isMaxErrors && !isMaxUsers && (React.createElement(Alert, { status: TAlertStatus.ERROR },
        React.createElement(Typography, { variant: "body-base", component: "div" },
            React.createElement("strong", null, "Your file contains more than 20 errors."),
            " Correct the errors and then try uploading again.",
            React.createElement("ul", { className: "sui-list-disc sui-ml-5 sui-pt-3" },
                React.createElement("li", null,
                    "Make sure your file is formatted correctly with four columns labeled",
                    ' ',
                    React.createElement("strong", null, "First Name, Last Name, Email"),
                    " and",
                    ' ',
                    React.createElement("strong", null, "Role.")),
                React.createElement("li", null,
                    React.createElement(Link, { href: convertStringToBlobCSV(Papa.unparse(mapFieldsToCSVModel(fields))), download: "users.csv" }, "Download this CSV file"),
                    ' ',
                    "to correct errors on the invalid user entries.")))));
    var validationAlerts = shouldShowImportForm && (React.createElement(React.Fragment, null,
        !!validUsersLength && (React.createElement(Alert, { status: TAlertStatus.SUCCESS, "data-testid": "successAlert" },
            React.createElement(Typography, { variant: "body-base" },
                "You successfully validated ",
                validUsersLength,
                " of ",
                totalUsersLength,
                ' ',
                "users and they're ready to import."))),
        !!invalidUsersLength && (React.createElement(Alert, { status: TAlertStatus.ERROR },
            React.createElement(Typography, { variant: "body-base" },
                "We couldn't validate ",
                invalidUsersLength,
                " user(s). Please correct the user details or remove invalid users to continue to import.")))));
    if (!isInitialValidated)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h3" }, "Import Results"),
        React.createElement("div", { className: "sui-py-8" },
            validationAlerts,
            maxErrorsAlert,
            maxUsersAlert),
        shouldShowImportForm ? (React.createElement(React.Fragment, null,
            React.createElement("form", { onSubmit: handleSubmit(onSubmitUsers) },
                React.createElement("div", { className: "lg:-sui-mr-[92px]" }, paginatedUsers === null || paginatedUsers === void 0 ? void 0 : paginatedUsers.map(function (_a, ind) {
                    var _b;
                    var id = _a.id;
                    var index = ind + (currentPageNumber - 1) * BULK_ADD_USERS_PAGE_SIZE;
                    var isUserValid = !((_b = formErrors.users) === null || _b === void 0 ? void 0 : _b[index]);
                    return (React.createElement("div", { key: id, className: "sui-flex sui-flex-wrap lg:sui-flex-nowrap sui-gap-x-8 sui-gap-y-4 lg:sui-gap-y-0 sui-mb-10 sui-justify-items-start" },
                        React.createElement("div", { className: "sui-w-full lg:sui-max-w-[203px]" },
                            React.createElement(Controller, { name: "users.".concat(index, ".firstName"), control: control, render: function (_a) {
                                    var _b, _c, _d, _e, _f;
                                    var field = _a.field;
                                    var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                                    return (React.createElement(TextField, { label: "First Name", fullWidth: true, required: true, id: "fName".concat(id), type: "text", status: ((_c = (_b = formErrors.users) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.firstName)
                                            ? 'error'
                                            : null, statusMessage: (_f = (_e = (_d = formErrors.users) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.firstName) === null || _f === void 0 ? void 0 : _f.message, value: value || '', name: name, onChange: onChange, InputProps: { inputProps: __assign({}, rest) } }));
                                } })),
                        React.createElement("div", { className: "sui-w-full lg:sui-max-w-[203px]" },
                            React.createElement(Controller, { name: "users.".concat(index, ".lastName"), control: control, render: function (_a) {
                                    var _b, _c, _d, _e, _f;
                                    var field = _a.field;
                                    var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                                    return (React.createElement(TextField, { label: "Last Name", fullWidth: true, required: true, id: "lName".concat(index), type: "text", status: ((_c = (_b = formErrors.users) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.lastName)
                                            ? 'error'
                                            : null, statusMessage: (_f = (_e = (_d = formErrors.users) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.lastName) === null || _f === void 0 ? void 0 : _f.message, value: value || '', name: name, onChange: onChange, InputProps: { inputProps: __assign({}, rest) } }));
                                } })),
                        React.createElement("div", { className: "sui-w-full lg:sui-max-w-[267px]" },
                            React.createElement(Controller, { name: "users.".concat(index, ".email"), control: control, render: function (_a) {
                                    var _b, _c, _d, _e, _f;
                                    var field = _a.field;
                                    var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                                    return (React.createElement(TextField, __assign({}, field, { label: "Email", fullWidth: true, required: true, id: "email".concat(index), type: "email", status: ((_c = (_b = formErrors.users) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.email)
                                            ? 'error'
                                            : null, statusMessage: (_f = (_e = (_d = formErrors.users) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.email) === null || _f === void 0 ? void 0 : _f.message, value: value || '', name: name, onChange: onChange, InputProps: { inputProps: __assign({}, rest) } })));
                                } })),
                        React.createElement("div", { className: "sui-w-full lg:sui-max-w-[139px]" },
                            React.createElement(Controller, { name: "users.".concat(index, ".role"), control: control, render: function (_a) {
                                    var _b, _c, _d, _e, _f;
                                    var field = _a.field;
                                    var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                                    var lowerCaseRole = value === null || value === void 0 ? void 0 : value.toLocaleLowerCase();
                                    return (React.createElement(FormController, { fullWidth: true },
                                        React.createElement(FormLabel, { required: true, htmlFor: "role".concat(index) }, "Role"),
                                        React.createElement(Dropdown, __assign({}, rest, { id: "role".concat(index), key: "".concat(index).concat(lowerCaseRole), value: lowerCaseRole, placeholder: "Select Role", name: name, onChange: onChange }),
                                            React.createElement(MenuItem, { value: ROLE_VALUES.purchaser },
                                                React.createElement("span", { className: "sui-capitalize" }, ROLE_VALUES.purchaser)),
                                            React.createElement(MenuItem, { value: ROLE_VALUES.admin },
                                                React.createElement("span", { className: "sui-capitalize" }, ROLE_VALUES.admin)),
                                            isPartOfRunnerAllowance && (React.createElement(MenuItem, { value: ROLE_VALUES.runner },
                                                React.createElement("span", { className: "sui-capitalize" }, ROLE_VALUES.runner)))),
                                        ((_d = (_c = (_b = formErrors.users) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.role) === null || _d === void 0 ? void 0 : _d.message) && (React.createElement(FormStatusMessage, { status: "error" }, (_f = (_e = formErrors.users[index]) === null || _e === void 0 ? void 0 : _e.role) === null || _f === void 0 ? void 0 : _f.message))));
                                } })),
                        React.createElement("div", { className: "sui-w-full lg:sui-max-w-[60px]" },
                            React.createElement("div", { className: "sui-hidden lg:sui-block sui-invisible" },
                                React.createElement(FormLabel, null, "\u00A0")),
                            React.createElement("div", { className: "lg:sui-h-[44px] sui-flex sui-items-center" }, isUserValid ? (React.createElement(ConfirmedFilled, { color: "success" })) : (React.createElement(Link, { "data-testid": "removeUserRowBtn", component: "button", onClick: function () { return onRemove(index); } }, "Remove"))))));
                })),
                React.createElement("div", { className: "sui-pt-8 sui-flex sui-space-x-4 sui-justify-end" },
                    React.createElement(Button, { variant: "secondary", onClick: handleCancelImport, "data-testid": "cancelImportBottomBtn" }, "Cancel Import"),
                    formErrors.users ? (React.createElement(Button, { variant: "primary", type: "button", onClick: openConfirmRemoveModal }, "Remove Invalid Users and Continue")) : (React.createElement(Button, { variant: "primary", type: "submit" }, "Import Users")))),
            totalPages > 1 && (React.createElement("div", { className: "sui-w-full sui-justify-center sui-mt-8 sui-flex sui-leading-[initial]" },
                React.createElement(Pagination, { currentPage: currentPageNumber, totalPages: totalPages, onPageChanged: onChangePage, showArrows: true }))))) : (React.createElement("div", { className: "sui-flex sui-space-x-4 sui-justify-end" },
            React.createElement(Button, { variant: "secondary", onClick: function () { return setFormMode(null); } }, "Cancel"),
            React.createElement(Button, { variant: "primary", onClick: setUploadStep }, "Back to Import")))));
};
